import axios from '@/api/axios';
import lang from '@/lang';
import * as permissions from '@core/dict/permissions';
import Vapi from 'vuex-rest-api';

const permission = new Vapi({
  axios,
  state: {},
});

const getAllChildren = el => {
  if (el.children) {
    const list = el.children.flatMap(x => getAllChildren(x));
    const perm = { ...el };
    delete perm.children;

    return [perm].concat(list);
  }
  return el;
};

permission.getters = {
  permissionTypeList: (s, g) => g.permissionTypes.flatMap(x => getAllChildren(x)),
  permissionTypes: () => [
    {
      name: 'PackOs',
      text: lang.t('general.packOs'),
      children: [
        {
          name: permissions.PACKOS_PLANT_ADMIN,
          text: lang.t('permissions.plantAdminAccess'),
          description: lang.t('permissions.plantAdminAccessDescription'),
          arg: 'PlantId',
          children: [
            {
              name: permissions.PACKOS_ELEMENT_ACCESS,
              text: lang.t('permissions.plantElementAccess'),
              description: lang.t('permissions.plantElementAccessDescription'),
              arg: 'LineId',
            },
            {
              name: permissions.PACKOS_DOWNTIME_MANAGEMENT,
              text: lang.t('permissions.manageDowntimes'),
              description: lang.t('permissions.manageDowntimesDescription'),
              arg: 'LineId',
              children: [
                {
                  name: permissions.PACKOS_MANUAL_DOWNTIME,
                  text: lang.t('permissions.manualDowntime'),
                  description: lang.t('permissions.manualDowntimeDescription'),
                  arg: 'LineId',
                },
                {
                  name: permissions.PACKOS_DOWNTIME_CHANGE,
                  text: lang.t('permissions.changeDowntimes'),
                  description: lang.t('permissions.changeDowntimesDescription'),
                  arg: 'LineId',
                },
              ],
            },
            {
              name: permissions.PACKOS_ORDER_MANAGEMENT,
              text: lang.t('permissions.orderManagement'),
              description: lang.t('permissions.orderManagementDescription'),
              arg: 'LineId',
              children: [
                {
                  name: permissions.PACKOS_ORDER_CREATE,
                  text: lang.t('permissions.orderCreate'),
                  description: lang.t('permissions.orderCreateDescription'),
                  arg: 'LineId',
                },
                {
                  name: permissions.PACKOS_ORDER_VIEW,
                  text: lang.t('permissions.orderViewAccess'),
                  description: lang.t('permissions.orderViewAccessDescription'),
                  arg: 'LineId',
                },
                {
                  name: permissions.PACKOS_ORDER_COMPLETED_MANUALPRODUCTION,
                  text: lang.t('permissions.orderCompleteManualProduction'),
                  description: lang.t('permissions.orderCompleteManualProductionDescription'),
                  arg: 'LineId',
                },
                {
                  name: permissions.PACKOS_ORDER_INPROGRESS_EDIT,
                  text: lang.t('permissions.orderInprogressEdit'),
                  description: lang.t('permissions.orderInprogressEditDescription'),
                  arg: 'LineId',
                },
                {
                  name: permissions.PACKOS_ORDER_COMPLETED_EDIT,
                  text: lang.t('permissions.orderCompleteEdit'),
                  description: lang.t('permissions.orderCompleteEditDescription'),
                  arg: 'LineId',
                },
                {
                  name: permissions.PACKOS_ORDER_LIFECYCLE,
                  text: lang.t('permissions.orderLifecycle'),
                  description: lang.t('permissions.orderLifecycleDescription'),
                  arg: 'LineId',
                },
                {
                  name: permissions.PACKOS_ORDER_EDIT,
                  text: lang.t('permissions.orderEdit'),
                  description: lang.t('permissions.orderEditDescription'),
                  arg: 'LineId',
                },
                {
                  name: permissions.PACKOS_MANUAL_PRODUCTION,
                  text: lang.t('permissions.manualProduction'),
                  description: lang.t('permissions.manualProductionDescription'),
                  arg: 'LineId',
                },
                {
                  name: permissions.PACKOS_ORDER_WITHDRAW,
                  text: lang.t('permissions.orderWithdraw'),
                  description: lang.t('permissions.orderWithdrawDescription'),
                  arg: 'LineId',
                },
              ],
            },
            {
              name: permissions.PACKOS_MATERIAL_MANAGEMENT,
              text: lang.t('permissions.materialManagement'),
              description: lang.t('permissions.materialManagementDescription'),
              arg: 'PlantId',
              children: [
                {
                  name: permissions.PACKOS_SKU_LIST,
                  text: lang.t('permissions.showSkuList'),
                  description: lang.t('permissions.showSkuListDescription'),
                  arg: 'PlantId',
                },
                {
                  name: permissions.PACKOS_SKU_EDIT,
                  text: lang.t('permissions.editSkuList'),
                  description: lang.t('permissions.editSkuListDescription'),
                  arg: 'PlantId',
                },
              ],
            },
            {
              name: permissions.PACKOS_STATES_MANAGEMENT,
              text: lang.t('permissions.statesManagement'),
              description: lang.t('permissions.statesManagementDescription'),
              arg: 'PlantId',
              children: [
                {
                  name: permissions.PACKOS_STATES_EDIT,
                  text: lang.t('permissions.statesEdit'),
                  description: lang.t('permissions.statesEditDescription'),
                  arg: 'PlantId',
                },
                {
                  name: permissions.PACKOS_REASON_ADD,
                  text: lang.t('permissions.addReason'),
                  description: lang.t('permissions.addReasonDescription'),
                  arg: 'LineId',
                },
                {
                  name: permissions.PACKOS_CORRECTIVE_ACTION_ADD,
                  text: lang.t('permissions.addCorrectiveAction'),
                  description: lang.t('permissions.addCorrectiveActionDescription'),
                  arg: 'LineId',
                },
                {
                  name: permissions.PACKOS_PROBLEMS_EDIT,
                  text: lang.t('permissions.editProblems'),
                  description: lang.t('permissions.editProblemsDescription'),
                  arg: 'LineId',
                },
              ],
            },
            {
              name: permissions.PACKOS_REPORT_ACCESS,
              text: lang.t('permissions.reportAccess'),
              description: lang.t('permissions.reportAccessDescription'),
              arg: 'PlantId',
            },
            {
              name: permissions.PACKOS_FLOW,
              text: lang.t('permissions.configFlow'),
              description: lang.t('permissions.configFlowDescription'),
              arg: 'PlantId',
            },
            {
              name: permissions.PACKOS_ELEMENTS_ORDER,
              text: lang.t('permissions.elementsOrder'),
              description: lang.t('permissions.elementsOrderDescription'),
              arg: 'PlantId',
            },
            {
              name: permissions.PACKOS_UNITS,
              text: lang.t('permissions.unitsEdit'),
              description: lang.t('permissions.unitsEditDescription'),
              arg: 'PlantId',
            },
            {
              name: permissions.PACKOS_SHIFTS,
              text: lang.t('permissions.configShifts'),
              description: lang.t('permissions.configShiftsDescription'),
              arg: 'PlantId',
            },
            {
              name: permissions.PACKOS_SIGNALS,
              text: lang.t('permissions.configSignals'),
              description: lang.t('permissions.configSignalsDescription'),
              arg: 'PlantId',
            },
            {
              name: permissions.PACKOS_TARGETS_CONFIG,
              text: lang.t('permissions.targetConfig'),
              description: lang.t('permissions.targetConfigDescription'),
              arg: 'PlantId',
            },
            {
              name: permissions.PACKOS_IMPORTER,
              text: lang.t('permissions.importer'),
              description: lang.t('permissions.importerDescription'),
              arg: 'PlantId',
            },
            {
              name: permissions.PACKOS_CUSTOM_REPORT_MANAGEMENT,
              text: lang.t('permissions.customReportManagement'),
              description: lang.t('permissions.customReportManagementDescription'),
              arg: 'PlantId',
            },
            {
              name: permissions.PACKOS_FUNCTIONS_CONFIG,
              text: lang.t('permissions.functionsConfig'),
              description: lang.t('permissions.functionsConfigDescription'),
              arg: 'PlantId',
            },
            {
              name: permissions.PACKOS_HINTS_CONFIG,
              text: lang.t('permissions.hintsConfig'),
              description: lang.t('permissions.hintsConfigDescription'),
              arg: 'PlantId',
            },
            {
              name: permissions.PACKOS_IMPORT_TEMPLATES_MANAGEMENT,
              text: lang.t('permissions.importTemplatesManagement'),
              description: lang.t('permissions.importTemplatesManagementDescription'),
              arg: 'PlantId',
            },
            {
              name: permissions.PACKOS_ACTIVITY_TYPES_MANAGEMENT,
              text: lang.t('permissions.activityTypesManagement'),
              description: lang.t('permissions.activityTypesManagementDescription'),
              arg: 'PlantId',
            },
            {
              name: permissions.PACKOS_WORKLOG_RERUN,
              text: lang.t('permissions.worklogRerun'),
              description: lang.t('permissions.worklogRerunDescription'),
              arg: 'PlantId',
            },
          ],
        },
      ],
    },
    {
      name: 'HUB',
      text: lang.t('general.config'),
      children: [
        {
          name: permissions.CONFIG_TENANT_ADMIN,
          text: lang.t('permissions.tenantAdminAccess'),
          description: lang.t('permissions.tenantAdminAccessDescription'),
          arg: 'TenantId',
          children: [
            {
              name: permissions.CONFIG_USER_MANAGEMENT,
              text: lang.t('permissions.usersManagementAccess'),
              description: lang.t('permissions.usersManagementAccessDescription'),
              arg: 'TenantId',
              children: [
                {
                  name: permissions.CONFIG_NOTIFICATIONS,
                  text: lang.t('permissions.notificationEdit'),
                  description: lang.t('permissions.notificationEditDescription'),
                  arg: 'TenantId',
                },
              ],
            },
          ],
        },
        {
          name: permissions.CONFIG_PLANT_ADMIN,
          text: lang.t('permissions.plantConfig'),
          description: lang.t('permissions.plantConfigDescription'),
          arg: 'PlantId',
        },
        {
          name: permissions.CONFIG_LICENSE_TENANT_ACCESS,
          text: lang.t('permissions.tenantLicenseAccess'),
          description: lang.t('permissions.tenantLicenseAccessDescription'),
          arg: 'TenantId',
        },
      ],
    },
    {
      name: 'KEEPUP',
      text: lang.t('general.keepup'),
      children: [
        {
          name: permissions.KEEPUP_PLANT_ADMIN,
          text: lang.t('permissions.plantAdminAccess'),
          description: lang.t('permissions.plantAdminAccessDescription'),
          arg: 'PlantId',
          children: [
            {
              name: permissions.KEEPUP_WRITE,
              text: lang.t('permissions.writeAccess'),
              description: lang.t('permissions.writeAccessDescription'),
              arg: 'LineId',
              children: [
                {
                  name: permissions.KEEPUP_READ,
                  text: lang.t('permissions.readAccess'),
                  description: lang.t('permissions.readAccessDescription'),
                  arg: 'LineId',
                },
              ],
            },
          ],
        },
        {
          name: permissions.KEEPUP_PLANT_ACCESS,
          text: lang.t('permissions.plantAccess'),
          description: lang.t('permissions.plantAccessDescription'),
          arg: 'PlantId',
        },
      ],
    },
    {
      name: 'WORKBOOST',
      text: lang.t('general.workboost'),
      children: [
        {
          name: permissions.WORKBOOST_TENANT_ADMIN,
          text: lang.t('permissions.tenantAdminAccess'),
          description: lang.t('permissions.tenantAdminAccessDescription'),
          arg: 'TenantId',
          children: [
            {
              name: permissions.WORKBOOST_TENANT_PROJECT_CREATE,
              text: lang.t('permissions.projectCreate'),
              description: lang.t('permissions.projectCreateDescription'),
              arg: 'TenantId',
            },
            {
              name: permissions.WORKBOOST_PROJECT_ADMIN,
              text: lang.t('permissions.projectAdmin'),
              description: lang.t('permissions.projectAdminDescription'),
              arg: 'TenantId',
              children: [
                {
                  name: permissions.WORKBOOST_PROJECT_VIEW,
                  text: lang.t('permissions.projectView'),
                  description: lang.t('permissions.projectViewDescription'),
                  arg: 'TenantId',
                },
                {
                  name: permissions.WORKBOOST_TEMPLATES_MANAGEMENT,
                  text: lang.t('permissions.templatesManagement'),
                  description: lang.t('permissions.templatesManagementDescription'),
                  arg: 'TenantId',
                },
                {
                  name: permissions.WORKBOOST_PROJECT_QUESTS_CREATE,
                  text: lang.t('permissions.questsCreate'),
                  description: lang.t('permissions.questsCreateDescription'),
                  arg: 'TenantId',
                },
              ],
            },
            {
              name: permissions.WORKBOOST_GROUP_ADMIN,
              text: lang.t('permissions.questGroupAdmin'),
              description: lang.t('permissions.questGroupAdminDescription'),
              arg: 'TenantId',
              children: [
                {
                  name: permissions.WORKBOOST_GROUP_QUESTS_VIEW,
                  text: lang.t('permissions.groupQuests'),
                  description: lang.t('permissions.groupQuestsDescription'),
                  arg: 'TenantId',
                },
              ],
            },
            {
              name: permissions.WORKBOOST_REPORT_ACCESS,
              text: lang.t('permissions.reportAccess'),
              description: lang.t('permissions.reportAccessDescription'),
              arg: 'TenantId',
            },
          ],
        },
      ],
    },
    {
      name: 'LOGICPRINT5',
      text: lang.t('general.logicprint5'),
      children: [
        {
          name: permissions.LOGICPRINT5_LABELLING,
          text: lang.t('permissions.labelling'),
          description: lang.t('permissions.labellingDescription'),
          arg: 'TenantId',
        },
        {
          name: permissions.LOGICPRINT5_SERIALIZATION_AND_AGGREGATION,
          text: lang.t('permissions.serializationAndAggregation'),
          description: lang.t('permissions.serializationAndAggregationDescription'),
          arg: 'TenantId',
        },
        {
          name: permissions.LOGICPRINT5_ORDERS,
          text: lang.t('permissions.orders'),
          description: lang.t('permissions.ordersDescription'),
          arg: 'TenantId',
        },
        {
          name: permissions.LOGICPRINT5_SKU,
          text: lang.t('permissions.sku'),
          description: lang.t('permissions.skuDescription'),
          arg: 'TenantId',
        },
        {
          name: permissions.LOGICPRINT5_LABELS,
          text: lang.t('permissions.labels'),
          description: lang.t('permissions.labelsDescription'),
          arg: 'TenantId',
        },
        {
          name: permissions.LOGICPRINT5_REQUESTS,
          text: lang.t('permissions.requests'),
          description: lang.t('permissions.requestsDescription'),
          arg: 'TenantId',
        },
        {
          name: permissions.LOGICPRINT5_SETTINGS,
          text: lang.t('permissions.settings'),
          description: lang.t('permissions.settingsDescription'),
          arg: 'TenantId',
        },
      ],
    },
    {
      name: 'LOGICPRINT7',
      text: lang.t('general.logicprint7'),
      children: [
        {
          name: permissions.LOGICPRINT7_COCKPIT_MANAGEMENT,
          text: lang.t('permissions.cockpitManagement'),
          description: lang.t('permissions.cockpitManagementDescription'),
          arg: 'LpPlantId',
          children: [
            {
              name: permissions.LOGICPRINT7_COCKPIT_VIEW,
              text: lang.t('permissions.cockpitView'),
              description: lang.t('permissions.cockpitViewDescription'),
              arg: 'LpPlantId',
            },
            {
              name: permissions.LOGICPRINT7_COCKPIT_OPERATIONS,
              text: lang.t('permissions.cockpitOperations'),
              description: lang.t('permissions.cockpitOperationsDescription'),
              arg: 'LpPlantId',
            },
            {
              name: permissions.LOGICPRINT7_COCKPIT_RESTRICTIONS,
              text: lang.t('permissions.cockpitRestrictions'),
              description: lang.t('permissions.cockpitRestrictionsDescription'),
              arg: 'LpPlantId',
            },
          ],
        },
        {
          name: permissions.LOGICPRINT7_ORDERS_MANAGEMENT,
          text: lang.t('permissions.ordersManagement'),
          description: lang.t('permissions.ordersManagementDescription'),
          arg: 'LpPlantId',
          children: [
            {
              name: permissions.LOGICPRINT7_ORDERS_VIEW,
              text: lang.t('permissions.ordersView'),
              description: lang.t('permissions.ordersViewDescription'),
              arg: 'LpPlantId',
            },
            {
              name: permissions.LOGICPRINT7_ORDERS_LIFECYCLE,
              text: lang.t('permissions.ordersLifecycle'),
              description: lang.t('permissions.ordersLifecycleDescription'),
              arg: 'LpPlantId',
            },
            {
              name: permissions.LOGICPRINT7_ORDERS_EDIT,
              text: lang.t('permissions.ordersEdit'),
              description: lang.t('permissions.ordersEditDescription'),
              arg: 'LpPlantId',
            },
            {
              name: permissions.LOGICPRINT7_ORDERS_CREATE,
              text: lang.t('permissions.ordersCreate'),
              description: lang.t('permissions.ordersCreateDescription'),
              arg: 'LpPlantId',
            },
          ],
        },
        {
          name: permissions.LOGICPRINT7_SKU_MANAGEMENT,
          text: lang.t('permissions.skuManagement'),
          description: lang.t('permissions.skuManagementDescription'),
          arg: 'LpPlantId',
          children: [
            {
              name: permissions.LOGICPRINT7_SKU_VIEW,
              text: lang.t('permissions.skuView'),
              description: lang.t('permissions.skuViewDescription'),
              arg: 'LpPlantId',
            },
            {
              name: permissions.LOGICPRINT7_SKU_EDIT,
              text: lang.t('permissions.skuEdit'),
              description: lang.t('permissions.skuEditDescription'),
              arg: 'LpPlantId',
            },
            {
              name: permissions.LOGICPRINT7_SKU_RESTRICTIONS,
              text: lang.t('permissions.skuRestrictions'),
              description: lang.t('permissions.skuRestrictionsDescription'),
              arg: 'LpPlantId',
            },
          ],
        },
        {
          name: permissions.LOGICPRINT7_PALLETS_MANAGEMENT,
          text: lang.t('permissions.palletsManagement'),
          description: lang.t('permissions.palletsManagementDescription'),
          arg: 'LpPlantId',
          children: [
            {
              name: permissions.LOGICPRINT7_PALLETS_VIEW,
              text: lang.t('permissions.palletsView'),
              description: lang.t('permissions.palletsViewDescription'),
              arg: 'LpPlantId',
            },
            {
              name: permissions.LOGICPRINT7_PALLETS_LIFECYCLE,
              text: lang.t('permissions.palletsLifecycle'),
              description: lang.t('permissions.palletsLifecycleDescription'),
              arg: 'LpPlantId',
            },
          ],
        },
        {
          name: permissions.LOGICPRINT7_SETTINGS,
          text: lang.t('permissions.settings'),
          description: lang.t('permissions.settingsDescription'),
          arg: 'LpPlantId',
        },
      ],
    },
    {
      name: 'GOODIN',
      text: lang.t('general.goodin'),
      children: [
        {
          name: permissions.GOODIN_PLANNING,
          text: lang.t('permissions.planning'),
          description: lang.t('permissions.planningDescription'),
          arg: 'TenantId',
        },
        {
          name: permissions.GOODIN_PRODUCTION,
          text: lang.t('permissions.production'),
          description: lang.t('permissions.productionDescription'),
          arg: 'TenantId',
        },
        {
          name: permissions.GOODIN_ARCHIVE,
          text: lang.t('permissions.archive'),
          description: lang.t('permissions.archiveDescription'),
          arg: 'TenantId',
        },
        {
          name: permissions.GOODIN_IMPORT_LOG,
          text: lang.t('permissions.importLog'),
          description: lang.t('permissions.importLogDescription'),
          arg: 'TenantId',
        },
      ],
    },
    {
      name: 'GOODIN-QA',
      text: lang.t('general.goodinQa'),
      children: [
        {
          name: permissions.GOODINQA_WEB_QUALITY_SAMPLES,
          text: lang.t('permissions.goodInQAWebQualitySamples'),
          description: lang.t('permissions.goodInQAWebQualitySamplesDescription'),
          arg: 'TenantId',
        },
        {
          name: permissions.GOODINQA_WEB_PALLETS,
          text: lang.t('permissions.goodInQAWebPallets'),
          description: lang.t('permissions.goodInQAWebPalletsDescription'),
          arg: 'TenantId',
        },
        {
          name: permissions.GOODINQA_MOBILE_QUALITY_SAMPLES,
          text: lang.t('permissions.goodInQAMobileQualitySamples'),
          description: lang.t('permissions.goodInQAMobileQualitySamplesDescription'),
          arg: 'TenantId',
        },
        {
          name: permissions.GOODINQA_MOBILE_WAREHOUSE,
          text: lang.t('permissions.goodInQAMobilePallets'),
          description: lang.t('permissions.goodInQAMobilePalletsDescription'),
          arg: 'TenantId',
        },
      ],
    },
    {
      name: 'BUCKETSERVICE',
      text: lang.t('general.bucketService'),
      children: [
        {
          name: permissions.BUCKETSERVICE_WEB_REWORKS_REPORT,
          text: lang.t('permissions.bucketServiceWebReworksReport'),
          description: lang.t('permissions.bucketServiceWebReworksReportDescription'),
          arg: 'TenantId',
        },
        {
          name: permissions.BUCKETSERVICE_WEB_MIX_COCKPIT,
          text: lang.t('permissions.bucketServiceWebMixCockpit'),
          description: lang.t('permissions.bucketServiceWebMixCockpitDescription'),
          arg: 'TenantId',
        },
        {
          name: permissions.BUCKETSERVICE_WEB_MIX_ARCHIVE,
          text: lang.t('permissions.bucketServiceWebMixArchive'),
          description: lang.t('permissions.bucketServiceWebMixArchiveDescription'),
          arg: 'TenantId',
        },
        {
          name: permissions.BUCKETSERVICE_MOBILE_REWORKS,
          text: lang.t('permissions.bucketServiceMobileReworks'),
          description: lang.t('permissions.bucketServiceMobileReworksDescription'),
          arg: 'TenantId',
        },
      ],
    },
    {
      name: 'KSM',
      text: 'KSM Vision',
      children: [
        {
          name: permissions.KSM_OPERATOR,
          text: 'Operator',
          description: 'Run day-to-day operator tasks in KSM Vision.',
          arg: 'TenantId',
        },
        {
          name: permissions.KSM_PRODUCTION_ASSISTANCE,
          text: 'Production Assistance',
          description: 'Access production assistance tools in KSM Vision.',
          arg: 'TenantId',
        },
        {
          name: permissions.KSM_ADMIN,
          text: 'Admin',
          description: 'Full administrative access to KSM Vision configuration.',
          arg: 'TenantId',
        },
        {
          name: permissions.KSM_SERVICE,
          text: 'Service',
          description: 'Access service and maintenance tools in KSM Vision.',
          arg: 'TenantId',
        },
      ],
    },
    {
      name: 'KNOWLAKE',
      text: lang.t('general.knowlake'),
    },
  ],
};

export default permission;
